<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model="form.supplierName" placeholder="请输入供应商名称" />
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address">
          <a-input v-model="form.address" placeholder="请输入地址" />
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="contactPerson">
          <a-input v-model="form.contactPerson" placeholder="请输入联系人" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="contactPhone">
          <a-input v-model="form.contactPhone" placeholder="请输入联系电话" />
        </a-form-model-item>
        <a-form-model-item label="归属商品">
          <a-select
            v-model="selectedGoodsIds"
            mode="multiple"
            placeholder="请选择归属商品(支持搜索)"
            show-search
            :filter-option="false"
            :default-active-first-option="false"
            :not-found-content="notFoundContent"
            @search="handleGoodsSearch"
            @change="handleGoodsChange"
            @dropdownVisibleChange="handleDropdownVisibleChange"
            style="width: 100%"
          >
            <template v-if="goodsSearchLoading" slot="notFoundContent">
              <a-spin size="small" />
            </template>
            <template v-else slot="notFoundContent">
              <span>暂无数据</span>
            </template>
            <a-select-option v-for="item in goodsOptions" :key="item.id" :value="item.id">
              {{ item.goodsName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { addSupplier, editSupplier, getSupplierGoods } from '@/api/retail/supplier'
import { pageGoods } from '@/api/goods/goods'
import { debounce } from 'lodash'

export default {
  name: 'SupplierForm',
  data() {
    this.handleGoodsSearch = debounce(this.handleGoodsSearch, 500)
    return {
      visible: false,
      confirmLoading: false,
      title: '新增供应商',
      form: {
        id: undefined,
        supplierName: '',
        address: '',
        contactPerson: '',
        contactPhone: ''
      },
      selectedGoodsIds: [],
      goodsOptions: [],
      goodsSearchLoading: false,
      notFoundContent: '暂无数据',
      supplierId: undefined
    }
  },
  methods: {
    handleAdd() {
      this.visible = true
      this.title = '新增供应商'
      this.form = {
        id: undefined,
        supplierName: '',
        address: '',
        contactPerson: '',
        contactPhone: ''
      }
      this.selectedGoodsIds = []
      this.goodsOptions = []
      this.supplierId = undefined
    },
    handleEdit(record) {
      this.visible = true
      this.title = '编辑供应商'
      this.form = {
        id: record.id,
        supplierName: record.supplierName,
        address: record.address,
        contactPerson: record.contactPerson,
        contactPhone: record.contactPhone
      }
      this.supplierId = record.id
      this.selectedGoodsIds = []
      this.goodsOptions = []
      // 加载该供应商的商品列表
      this.loadSupplierGoods(record.id)
    },
    async loadSupplierGoods(supplierId) {
      try {
        const response = await getSupplierGoods({ supplierId })
        if (response.data) {
          const supplierGoods = response.data
          this.selectedGoodsIds = supplierGoods.map(item => item.goodsId)
          // 同时加载商品详情到选项列表
          this.goodsOptions = supplierGoods.map(item => ({
            id: item.goodsId,
            goodsName: item.goodsName
          }))
        }
      } catch (error) {
        console.error('加载供应商商品失败:', error)
      }
    },
    async handleGoodsSearch(keyword) {
      this.goodsSearchLoading = true
      try {
        const response = await pageGoods({
          goodsName: keyword ? keyword.trim() : undefined,
          pageNum: 1,
          pageSize: 50
        })
        if (response.data && response.data.records) {
          this.goodsOptions = response.data.records
        } else {
          this.goodsOptions = []
        }
      } catch (error) {
        console.error('搜索商品失败:', error)
        this.goodsOptions = []
      } finally {
        this.goodsSearchLoading = false
      }
    },
    handleDropdownVisibleChange(open) {
      if (open) {
        // 打开下拉时加载一些默认商品
        this.handleGoodsSearch('')
      }
    },
    handleGoodsChange(selectedIds) {
      this.selectedGoodsIds = selectedIds
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const api = this.form.id ? editSupplier : addSupplier
          // 将商品ID列表合并到提交参数中
          const params = {
            ...this.form,
            goodsIds: this.selectedGoodsIds
          }
          api(params).then(() => {
            this.$message.success(this.form.id ? '修改成功' : '添加成功')
            this.visible = false
            this.$emit('ok')
          }).catch(() => {
            this.confirmLoading = false
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
